import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BoxImage, CTAButton } from './CTAButton';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-3 py-4 sm:px-6" data-id="element-113" data-mp="1mnitfen9rhez">
      <div className="mx-auto max-w-xl text-center" data-id="element-114" data-mp="1mpli9vcor4i4">
        <p className="font-body text-[0.66rem] font-extrabold uppercase tracking-[0.2em] text-gold sm:text-xs" data-id="element-115" data-mp="1ho60qd9pvg4h">
          Special launch offer
        </p>
        <h2 className="mt-1 font-heading text-[1.25rem] font-extrabold uppercase leading-tight text-white sm:text-[1.9rem]" data-id="element-116" data-mp="u0oc2qlr0y5q">
          🩻 Radiology Visual Atlas™
        </h2>
        <p className="mt-0.5 font-body text-[0.7rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.84rem]" data-id="element-117" data-mp="13yc95n6tuhr2">
          The Complete Visual Study System for Radiology Students
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[230px] sm:max-w-[280px]" target="checkout" data-id="element-118" data-mp="2fad1td6taqc3" />

        <div className="mt-2 rounded-md border border-gold/40 bg-white px-3 py-2.5 text-left" data-id="element-119" data-mp="2afft67dg2izq">
          <p className="text-center font-body text-[0.72rem] font-extrabold uppercase tracking-wide text-navy sm:text-[0.86rem]" data-id="element-120" data-mp="pml89msvtjdb">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-121" data-mp="zj6e2acq6yi7">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-122" data-mp="13j73eq1d4u41">
                <CheckIcon className="mt-[3px] h-3 w-3 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-123" data-mp="6usg1uln026n" />
                <span className="text-[0.75rem] leading-tight text-graphite sm:text-[0.86rem]" data-id="element-124" data-mp="ftvxyv92ibjk">
                  {b}
                </span>
              </li>)}
          </ul>
          <p className="mt-2 text-center font-body text-[0.8rem] font-extrabold uppercase leading-tight text-navy sm:text-[1rem]" data-id="element-125" data-mp="3k8vrqk1p0e9b">
            🔥 Get Radiology Visual Atlas™ today —{' '}
            <span className="text-teal" data-id="element-126" data-mp="vfqwo0z3taro">$26.90</span>
          </p>
          <div className="mt-1.5" data-id="element-127" data-mp="ve5z02hhtbpl">
            <CTAButton label="⚡ Get instant access" sub="Immediate Digital Access" target="checkout" data-id="element-128" data-mp="qgnpa9vnisgj" />
          </div>
          <p className="mt-1.5 text-center font-body text-[0.62rem] font-bold uppercase tracking-wide text-graphite sm:text-xs" data-id="element-129" data-mp="154r0pysgqwcq">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}